<p class="text-center py-4">Advertising</p>
<div class="col-12">
    <div class="col-6 float-start pe-1">
        <img src="./assets/images/ads/ads-2.png" class=" img-fluid" alt="...">
    </div>
    <div class="col-6 float-end ps-1">
        <img src="./assets/images/ads/ads-1.png" class="img-fluid" alt="...">
    </div>
</div>
